
/**
 * 20201218 add Session7EnNameLimit and Session7ChtNameLimit 字數限字
 */
/* 我的開發機 
const envConfig = {   
    kind01API : 'http://192.168.1.195:8080/api/GetApi',
    kind00API : 'http://192.168.1.195:8080/api/GetApi',
    email: 'http://192.168.1.195:8080/api/email',
    WebAPI: 'https://localhost:44312/api',
    ManageURL: 'http://localhost:3000/managerweb/',
    ImageDataAPI:'http://localhost:3000/',
    PositionCount:10,
    PositionAuto:1,
    LogoImageLimit:["png", "jpeg", "gif"],
    Session7EnNameLimit:30,
    Session7ChtNameLimit:4,
    AutoNoLimit:1,
    ImageFitNoWhite:'將圖片填滿欄位',
    ImageFit:'使用原比例',
    Subject: '您的企業品牌形象頁收到1筆「聯絡我們」資訊',
    DevMode:true
} */

/* 1111 Private 測試機  
const envConfig = {    
    kind01API : 'http://192.168.1.195:8080/api/GetApi',
    kind00API : 'http://192.168.1.195:8080/api/GetApi',
    email: 'http://192.168.1.195:8080/api/email',
    WebAPI: 'http://192.168.1.195:8080/api',
    ManageURL: 'http://192.168.1.195:3000/managerweb/',   
    ImageDataAPI:'http://192.168.1.195:3000/', 
    PositionCount:10,
    PositionAuto:1,
    LogoImageLimit:["png", "jpeg", "gif"],
    Session7EnNameLimit:30,
    Session7ChtNameLimit:4,
    AutoNoLimit:1,  
    ImageFitNoWhite:'將圖片填滿欄位',
    ImageFit:'使用原比例',
    Subject: '您的企業品牌形象頁收到1筆「聯絡我們」資訊',
    DevMode:false
} */

/* 1111 Public 正式機 */
const envConfig = {   
    kind01API : 'https://brand.1111.com.tw/WebAPI/api/GetApi',
    kind00API : 'https://brand.1111.com.tw/WebAPI/api/GetApi',
    email: 'https://brand.1111.com.tw/WebAPI/api/email',
    WebAPI: 'https://brand.1111.com.tw/WebAPI/api',
    ManageURL: 'https://brand.1111.com.tw/managerweb/', 
    ImageDataAPI:'https://brand.1111.com.tw/',       
    PositionCount:10,
    PositionAuto:1,
    LogoImageLimit:["png", "jpeg", "gif"],
    Session7EnNameLimit:30,
    Session7ChtNameLimit:4,
    AutoNoLimit:0,
    ImageFitNoWhite:'將圖片填滿欄位',
    ImageFit:'使用原比例',
    Subject: '您的企業品牌形象頁收到1筆「聯絡我們」資訊',
    DevMode:false
}

/* 1111 Public 正式機裡的 test 
const envConfig = {   
    kind01API : 'https://brandtest.1111.com.tw/WebAPI/api/GetApi',
    kind00API : 'https://brandtest.1111.com.tw/WebAPI/api/GetApi',
    email: 'https://brandtest.1111.com.tw/WebAPI/api/email',
    WebAPI: 'https://brandtest.1111.com.tw/WebAPI/api',
    ManageURL: 'https://brandtest.1111.com.tw/managerweb/', 
    ImageDataAPI:'https://brandtest.1111.com.tw/',       
    PositionCount:10,
    PositionAuto:1,
    LogoImageLimit:["png", "jpeg", "gif"],
    Session7EnNameLimit:30,
    Session7ChtNameLimit:4,
    AutoNoLimit:0,
    ImageFitNoWhite:'將圖片填滿欄位',
    ImageFit:'使用原比例',
    Subject: '您的企業品牌形象頁收到1筆「聯絡我們」資訊',
    DevMode:false
} */

export default envConfig;